module.exports = __webpack_public_path__ + "static/media/PCDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.89b0e1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/praticando/PCDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.png
// module id = 100
// module chunks = 0